// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2doik","label":"Completed_label__qtBs4"};